enum GeofenceGroupType {
  PROXIMITY = 1,
  AUDIENCE = 2,
}

export default GeofenceGroupType;
